import React from 'react';
import { Callout, Typography } from 'seagull';
import ContactSupportButton from "../../../components/ContactSupportButton";
import styles from "./PayoutFailedCallout.module.scss";
import { PayoutFailureCode } from "../../../models";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { helpArticles } from "../../../utils/helpArticles";
function getSuffix(code) {
  switch (code) {
    case PayoutFailureCode.MissingAuthorization:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExternalLinkButton, {
        testid: "handling-chargebacks-link",
        openInNewTab: true,
        href: helpArticles.chargebacksAndDisputes('missing-auth')
      }, "Learn more"), ' ', "about handling chargebacks.");
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "For assistance, please ", /*#__PURE__*/React.createElement(ContactSupportButton, {
        testid: "contact-support"
      }), ".");
  }
}
export default function PayoutFailedCallout(_ref) {
  let {
    payout,
    testid
  } = _ref;
  const payoutFailure = payout.payoutFailure();
  return payoutFailure ? /*#__PURE__*/React.createElement(Callout, {
    "data-testid": testid,
    intent: "warning",
    className: styles.payoutFailedCallout
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    as: "span"
  }, "Payout failed."), ' ', payoutFailure.message, " ", getSuffix(payoutFailure.code))) : null;
}